import React from "react";

import Table from "../../common/Table";
import calc from "../../../utils/calculation";
import lbl from "../../../data/Labels.json";

const PaymentsList = ({data}) => {
    const paymentsColumn = [
        { path: "id", label: "شماره" },
        { path: "payment_date", label: "تاریخ" },
        { path: "paid_by_staff_name", label: "پرداخت کننده" },
        { path: "modified_by_staff_name", label: "ثبت کننده" },
        { path: "remark", label: "ملاحظه" },
        { path: "bank_ref_no", label: "ریفرنس نمبر" },
        { path: "amount", label: "مبلغ" },
    ]

    const summary = {
        "amount": calc.getTotal(data, "amount"),
    }

    return (
        <div className="print-table-area">
            <Table
                data={{data, summary}}
                columns={paymentsColumn}
            />
        </div>
    );
};

export default PaymentsList;
